import { z } from 'zod';

export const ForgetPasswordSchema = z.object({
  email: z.string().nonempty('required').email('email'),
});

export type TForgetPasswordSchema = z.infer<typeof ForgetPasswordSchema>;
